// icons8-fuzzy-improved.js
// Enhanced fuzzy icon resolver with multi-attempt strategy and better matching
import { Avatar, Space } from "antd";

const NAVIGATION_ICONS = [
  {
    label: "scaleflow",
    url: "https://img.icons8.com/ios-filled/50/FFFFFF/chevron-up.png",
    aliases: ["scaleflow", "rentlog"],
  },
  {
    label: "calendar",
    url: "https://img.icons8.com/sf-regular/48/FFFFFF/calendar.png",
    aliases: ["calendar", "schedule", "date"],
  },
  {
    label: "events",
    url: "https://img.icons8.com/ios-glyphs/90/FFFFFF/event-accepted.png",
    aliases: ["events", "meetings", "activity"],
  },
  {
    label: "tenant",
    url: "https://img.icons8.com/ios-filled/100/FFFFFF/organization.png",
    aliases: ["tenant", "organization", "company", "clients"],
  },
  {
    label: "invoicebuilder",
    url: "https://img.icons8.com/ios-glyphs/90/FFFFFF/invoice.png",
    aliases: ["invoicebuilder", "invoice", "billing", "receipt"],
  },
  {
    label: "manage workspace",
    url: "https://img.icons8.com/ios-filled/100/FFFFFF/under-computer.png",
    aliases: ["manage workspace", "settings", "admin"],
  },
  {
    label: "switch workspace",
    url: "https://img.icons8.com/sf-black-filled/64/FFFFFF/switch.png",
    aliases: ["switch workspace", "change", "swap"],
  },
  {
    label: "logout",
    url: "https://img.icons8.com/ios-glyphs/90/FFFFFF/exit.png",
    aliases: ["logout", "signout", "exit"],
  },
];

const ICONS = [
  {label: "logistics", url: "https://img.icons8.com/fluency/96/deliver-food.png", aliases: ["logistics"]},
  {label: "software", url: "https://img.icons8.com/color/96/software-box.png", aliases: ["tool", "application", "program"]},
  {label: "suite", url: "https://img.icons8.com/pastel-glyph/64/nft-collection.png", aliases: ["software suite", "collection", "bundle"]},
  {label: "company", url: "https://img.icons8.com/fluency/96/company.png", aliases: ["organization", "enterprise", "firm"]},
  {label: "discount", url: "https://img.icons8.com/ios-glyphs/30/discount-ticket.png", aliases: ["offer", "coupon", "deal"]},
  {label: "tax", url: "https://img.icons8.com/plumpy/24/tax.png", aliases: ["gst", "invoice", "vat"]},
  {label: "theme", url: "https://img.icons8.com/fluency/96/themes.png", aliases: ["appearance", "style", "color scheme"]},
  {label: "client info", url: "https://img.icons8.com/ios-filled/50/badge.png", aliases: ["customer", "profile", "user info"]},
  {label: "email", url: "https://img.icons8.com/material-two-tone/24/new-post.png", aliases: ["mail", "message", "communication"]},
  {label: "start date", url: "https://img.icons8.com/fluency/96/windows-calendar.png", aliases: ["begin", "from", "opening date", "startDate", "buydate"]},
  {label: "end date", url: "https://img.icons8.com/fluency/96/tear-off-calendar.png", aliases: ["closing", "expiry", "deadline", "endDate", "createdAt"]},
  {label: "description", url: "https://img.icons8.com/fluency/96/goodnotes--v1.png", aliases: ["notes", "details", "info"]},
  {label: "name", url: "https://img.icons8.com/color/96/gender-neutral-user.png", aliases: ["person", "contact name"]},
  {label: "address", url: "https://img.icons8.com/fluency/96/gps-device.png", aliases: ["location", "place", "map"]},
  {label: "contacts list", url: "https://img.icons8.com/fluency/96/contacts.png", aliases: ["clients", "users", "directory"]},
  {label: "counter", url: "https://img.icons8.com/fluency/96/counter.png", aliases: ["count", "meter", "value", "Total Rental/Products"]},
  {label: "countdown", url: "https://img.icons8.com/fluency/96/stopwatch.png", aliases: ["timer", "time left", "clock", "CountDown to event"]},
  {label: "expense list", url: "https://img.icons8.com/fluency/96/banknotes.png", aliases: ["expenses", "costs", "finance", "payment", "Total Cost"]},
  {label: "property", url: "https://img.icons8.com/fluency/96/defensive-wood-wall.png", aliases: ["property", "rental", "apartment"]},
  {label: "tenant", url: "https://img.icons8.com/fluency/96/business.png", aliases: ["business", "tenant"]},
  {label: "phone", url: "https://img.icons8.com/fluency/96/smartphone.png", aliases: ["phone"]},
  {label: "equipment", url: "https://img.icons8.com/fluency/96/job.png", aliases: ["equipment"]},
  {label: "action", url: "https://img.icons8.com/fluency/96/conflict.png", aliases: ["action"]},
  {label: "frequency", url: "https://img.icons8.com/fluency/96/audio-wave.png", aliases: ["frequency"]},
  {label: "archived", url: "https://img.icons8.com/fluency/48/cancel-2.png", aliases: ["archived"]},
  {label: "rent amount", url: "https://img.icons8.com/fluency/96/cash-in-hand.png", aliases: ["rent amount", "subscription price", "buyvalue"]},
  {label: "status", url: "https://img.icons8.com/fluency/96/ok--v1.png", aliases: ["status", "active"]},
  {label: "overlap", url: "https://img.icons8.com/fluency/96/layers.png", aliases: ["overlap"]},
  {label: "Agreements", url: "https://img.icons8.com/fluency/96/handshake.png", aliases: ["agreements"]},
  {label: "rentlog", url: "https://img.icons8.com/fluency/96/collapse-arrow.png", aliases: ["rentlog", "scaleflow"]},
  {label: "workspace", url: "https://img.icons8.com/color/96/under-computer.png", aliases: ["workspace"]},
  {label: "user settings", url: "https://img.icons8.com/stickers/100/group--v1.png", aliases: ["user settings"]},
  {label: "workspace settings", url: "https://img.icons8.com/stickers/100/imac-settings.png", aliases: ["workspace settings"]},
  {label: "Auto Posting", url: "https://img.icons8.com/color/96/api.png", aliases: ["Auto Posting"]}
];

const FALLBACK_POOL = [
  "https://img.icons8.com/fluency/96/deliver-food.png",
  "https://img.icons8.com/color/96/software-box.png",
  "https://img.icons8.com/fluency/96/company.png",
  "https://img.icons8.com/fluency/96/banknotes.png",
  "https://img.icons8.com/fluency/96/gps-device.png",
  "https://img.icons8.com/fluency/96/contacts.png",
  "https://img.icons8.com/fluency/96/counter.png",
  "https://img.icons8.com/fluency/96/stopwatch.png",
  "https://img.icons8.com/fluency/96/defensive-wood-wall.png",
  "https://img.icons8.com/fluency/96/business.png",
  "https://img.icons8.com/fluency/96/smartphone.png",
  "https://img.icons8.com/fluency/96/job.png",
  "https://img.icons8.com/fluency/96/conflict.png",
  "https://img.icons8.com/fluency/96/audio-wave.png",
  "https://img.icons8.com/fluency/96/layers.png",
  "https://img.icons8.com/fluency/96/handshake.png",
  "https://img.icons8.com/fluency/96/collapse-arrow.png",
  "https://img.icons8.com/color/96/under-computer.png",
  "https://img.icons8.com/stickers/100/group--v1.png",
  "https://img.icons8.com/stickers/100/imac-settings.png",
  "https://img.icons8.com/fluency/96/api.png",
  "https://img.icons8.com/fluency/96/checked.png"
];

// Cache stores: normalized_label -> { url, isExisting }
const cache = new Map();

// --- IMPROVED NORMALIZATION ---
function norm(s) {
  if (typeof s !== "string") return "";

  // Handle camelCase, PascalCase, snake_case, kebab-case
  let normalized = s
    // Insert space before capital letters in camelCase
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    // Replace underscores and hyphens with spaces
    .replace(/[_-]/g, ' ')
    // Remove special characters except spaces
    .replace(/[^a-z0-9\s]/gi, ' ')
    // Convert to lowercase
    .toLowerCase()
    // Collapse multiple spaces
    .replace(/\s+/g, ' ')
    .trim();

  return normalized;
}

function tokens(s) {
  return norm(s).split(/\s+/).filter(Boolean);
}

// --- ENHANCED FUZZY SCORING ---
function score(query, candidate) {
  const q = tokens(query);
  const c = tokens(candidate);

  if (q.length === 0 || c.length === 0) return 0;

  const setQ = new Set(q);
  const setC = new Set(c);

  // 1. Token overlap (Jaccard similarity)
  let intersection = 0;
  for (const t of setQ) {
    if (setC.has(t)) intersection++;
  }
  const union = setQ.size + setC.size - intersection;
  let tokenScore = union ? intersection / union : 0;

  const nq = norm(query);
  const nc = norm(candidate);

  // 2. Exact match bonus
  if (nq === nc) return 1.0;

  // 3. Substring matching
  if (nc.includes(nq)) tokenScore += 0.4;
  if (nq.includes(nc)) tokenScore += 0.35;

  // 4. Start matching (important for predictable matches)
  if (nc.startsWith(nq)) tokenScore += 0.3;
  if (nq.startsWith(nc)) tokenScore += 0.25;

  // 5. Word boundary matching (whole word matches)
  const qWords = new Set(nq.split(/\s+/));
  const cWords = new Set(nc.split(/\s+/));
  let wordMatches = 0;
  for (const w of qWords) {
    if (cWords.has(w)) wordMatches++;
  }
  if (qWords.size > 0) {
    tokenScore += (wordMatches / qWords.size) * 0.2;
  }

  // 6. Length similarity bonus (prefer similar length matches)
  const lenDiff = Math.abs(nq.length - nc.length);
  const maxLen = Math.max(nq.length, nc.length);
  if (maxLen > 0) {
    tokenScore += (1 - lenDiff / maxLen) * 0.1;
  }

  return Math.min(tokenScore, 1.0);
}

// --- GENERATE MULTIPLE ICON URL VARIATIONS ---
function generateIcons8Urls(label, size = 96) {
  const normalized = norm(label);
  const slug = normalized.replace(/\s+/g, "-") || "help";
  const s = Math.max(16, Math.round(size));

  // Common icon styles on icons8 (ordered by likelihood)
  const styles = [
    "fluency",
    "color",
    "ios-filled",
    "ios-glyphs",
    "material-rounded",
    "sf-regular",
    "office",
    "stickers",
    "doodle",
    "pastel"
  ];

  const urls = [];

  // Try each style
  for (const style of styles) {
    urls.push(`https://img.icons8.com/${style}/${s}/${slug}.png`);
  }

  // Try with 000000 (black) for some styles
  urls.push(`https://img.icons8.com/fluency/${s}/000000/${slug}.png`);
  urls.push(`https://img.icons8.com/material-rounded/${s}/000000/${slug}.png`);

  // Try common variations of the slug
  const tokens = normalized.split(/\s+/);
  if (tokens.length > 1) {
    // Try first word only
    const firstWord = tokens[0];
    urls.push(`https://img.icons8.com/fluency/${s}/${firstWord}.png`);
    urls.push(`https://img.icons8.com/color/${s}/${firstWord}.png`);

    // Try last word only
    const lastWord = tokens[tokens.length - 1];
    urls.push(`https://img.icons8.com/fluency/${s}/${lastWord}.png`);
    urls.push(`https://img.icons8.com/color/${s}/${lastWord}.png`);
  }

  return urls;
}

// Deterministic fallback from pool
function pickFallbackForLabel(label) {
  const key = norm(label);
  let h = 0;
  for (let i = 0; i < key.length; i++) {
    h = (h << 5) - h + key.charCodeAt(i);
    h |= 0;
  }
  const idx = Math.abs(h) % FALLBACK_POOL.length;
  return FALLBACK_POOL[idx];
}

// --- CORE LOOKUP WITH BETTER THRESHOLD ---
function getBestIcon(label, navigation) {
  const key = norm(label);

  // Check cache first
  if (cache.has(key)) {
    return cache.get(key);
  }

  let best = { url: null, score: -1, isExisting: false };
  const ICONLIST = navigation ? NAVIGATION_ICONS : ICONS;

  // Search through existing icons
  for (const icon of ICONLIST) {
    const names = [icon.label, ...(icon.aliases || [])];
    for (const name of names) {
      const sc = score(label, name);
      if (sc > best.score) {
        best = { url: icon.url, score: sc, isExisting: true };
      }
    }
  }

  // Use a reasonable threshold - only accept if score is decent
  // This prevents weak matches from being used
  const MATCH_THRESHOLD = 0.3;

  let result;
  if (best.score >= MATCH_THRESHOLD) {
    result = { url: best.url, isExisting: true };
  } else {
    // No good match found - will try dynamic icons8 URLs
    result = { url: null, isExisting: false };
  }

  cache.set(key, result);
  return result;
}

// --- PUBLIC API ---
export function getIcon(label, avatar = false, { size = 48, html = false, alt = "", title = "" } = {}, navigation = false) {
  const result = getBestIcon(label, navigation);
  const altText = alt || label;

  // CASE A: Found existing icon - return it unchanged
  if (result.isExisting && result.url) {
    const src = result.url;

    if (avatar && title) {
      return (
        <Space align="center" style={{ gap: "2px" }} size={0}>
          <Avatar src={src} size={size} />
          {title}
        </Space>
      );
    }

    if (avatar) {
      return <Avatar src={src} size={size} />;
    }

    if (typeof React !== "undefined" && !html) {
      return <img src={src} width={size} height={size} alt={altText} style={{ verticalAlign: "middle" }} />;
    }

    return `<img src="${src}" width="${size}" height="${size}" alt="${altText}" style="vertical-align:middle"/>`;
  }

  // CASE B: No existing match - try multiple icons8 URLs
  const urlVariations = generateIcons8Urls(label, size);
  const fallback = pickFallbackForLabel(label);

  // Create a cascading onError handler that tries multiple URLs
  let currentIndex = 0;
  const tryNextUrl = function(e) {
    currentIndex++;
    if (currentIndex < urlVariations.length) {
      e.currentTarget.onerror = tryNextUrl;
      e.currentTarget.src = urlVariations[currentIndex];
    } else {
      // All variations failed - use fallback pool
      e.currentTarget.onerror = null;
      e.currentTarget.src = fallback;
    }
  };

  const firstUrl = urlVariations[0] || fallback;

  // Avatar + title
  if (avatar && title) {
    return (
      <Space align="center" style={{ gap: "2px" }} size={0}>
        <img
          src={firstUrl}
          width={size}
          height={size}
          alt={altText}
          style={{
            verticalAlign: "middle",
            width: size,
            height: size,
            borderRadius: "50%",
            objectFit: "cover"
          }}
          onError={tryNextUrl}
        />
        {title}
      </Space>
    );
  }

  // Avatar only
  if (avatar) {
    return (
      <img
        src={firstUrl}
        width={size}
        height={size}
        alt={altText}
        style={{
          verticalAlign: "middle",
          width: size,
          height: size,
          borderRadius: "50%",
          objectFit: "cover"
        }}
        onError={tryNextUrl}
      />
    );
  }

  // JSX
  if (typeof React !== "undefined" && !html) {
    return (
      <img
        src={firstUrl}
        width={size}
        height={size}
        alt={altText}
        style={{ verticalAlign: "middle", objectFit: "cover" }}
        onError={tryNextUrl}
      />
    );
  }

  // HTML string - more complex because we need to encode the cascade
  // For HTML, we'll just try the first URL and fallback directly
  const htmlOnError = `this.onerror=null;this.src='${fallback}'`;
  return `<img src="${firstUrl}" width="${size}" height="${size}" alt="${altText}" style="vertical-align:middle" onerror="${htmlOnError}"/>`;
}

// Export for debugging
export function debugIconMatch(label, navigation = false) {
  const ICONLIST = navigation ? NAVIGATION_ICONS : ICONS;
  const results = [];

  for (const icon of ICONLIST) {
    const names = [icon.label, ...(icon.aliases || [])];
    for (const name of names) {
      const sc = score(label, name);
      if (sc > 0) {
        results.push({
          label: icon.label,
          matchedName: name,
          score: sc,
          url: icon.url
        });
      }
    }
  }

  results.sort((a, b) => b.score - a.score);
  return results;
}
